import React from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useNavigate, useLocation } from 'react-router-dom';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { getCaseStyle, formatNull, formatDate } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';
import Loading from '../Loading';
import WarningPanel from '../WarningPanel';

import Modal from '../Modal';
import EditVerification from './Components/EditVerification';
import SingleVerification from './Components/SingleVerification';
import ModalRight from '../ModalRight';
import FileViewerModal from '../FileViewerModal';

import ButtonWithConfirmation from '../ButtonWithConfirmation';

import IconContainer from '../IconContainer';
import { ReactComponent as PenIcon } from '../../icons/pen.svg';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import { ReactComponent as EyeIcon } from '../../icons/eye.svg';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

const Verifications = ({ userId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { openTimeModal } = useTimeModal();

  const [cases, setCases] = React.useState([]);

  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  const [isAdmin, setIsAdmin] = React.useState(false);

  React.useEffect(() => {
      const token = localStorage.getItem('token');
  
      try {
          const decodedToken = jwtDecode(token);
          if (decodedToken.role==='АппаратСРО') {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
          }
      } catch (error) {
          console.error('Ошибка при декодировании токена: ', error);
      }
  }, []);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get(`/api/get-user-verifications?id=${userId}`)
    .then((response) => {
      setWarning('');
      setCases(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload, userId]);

  const deleteEntry = (id) => {
    const token = localStorage.getItem('token');

    axios.delete('/api/delete-verifications', {
      data: { id },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then((response) => {
      openTimeModal('Запись удалена', 'success');
      setReload(true);
    })
    .catch((error) => {
      openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const [isEditModal, setIsEditModal] = React.useState(false);

  const [currentId, setCurrentId] = React.useState('');
  const [currentAction, setCurrentAction] = React.useState('');

  const openSuperModal = (id, action) => {
    setCurrentId(id);
    setCurrentAction(action);
    setIsEditModal(true);
  };

  const [isFileViewerModal, setIsFileViewerModal] = React.useState(false);
  const [currentFileId, setCurrentFileId] = React.useState(null);

  const [isFullInfoModal, setIsFullInfoModal] = React.useState(false);


  return (
    <>
      <ModalRight isOpen={isFileViewerModal} closeModal={() => setIsFileViewerModal(false)} >
          <FileViewerModal closeModal={() => setIsFileViewerModal(false)} id={currentFileId} />
      </ModalRight>
      <Modal isOpen={isEditModal} closeModal={() => setIsEditModal(false)}>
          <EditVerification id={currentId} action={currentAction} userId={userId} onSuccess={() => setReload(true)} />
      </Modal>
      <Modal isOpen={isFullInfoModal} closeModal={() => setIsFullInfoModal(false)}>
          <SingleVerification id={currentId} />
      </Modal>

      <div className='tableContainer'>
        <div className='tableHeaderWrapper'>
          <div className='tableStatus'>
              {isAdmin ? 
              <button type='button' className='secondaryButton' onClick={() => {openSuperModal('', 'add')}}>
                <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                  <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                </svg>
                Добавить сведения о проверке
              </button>
              :
              <div></div>}
              <a className='lastUpdateWrapper'>
                  {loading ? 
                      <Loading type='inline' /> 
                  : 
                      <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                  }
              </a>
          </div>
          <div className='tableHeader' style={{ gridTemplateColumns: '8fr 10fr 20fr 20fr 13fr 23fr 6fr' }}>
              <div>Дата проверки</div>
              <div>Вид проверки</div>
              <div>Заявитель</div>
              <div>Должник</div>
              <div>Номер дела</div>
              <div>Результат</div>
              <div></div>
          </div>
        </div>
        {loading ? <LoadingLines /> 
        : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
        : cases.map((caseItem) => (
            <div 
              className='tableDoubleRow' 
              key={caseItem.id} 
            >
                <div 
                    className='row'
                    style={{ gridTemplateColumns: '8fr 10fr 20fr 20fr 13fr 23fr 6fr' }}
                >
                    <div>{formatDate(caseItem.date)}</div>
                    <div>{formatNull(caseItem.type)}</div>
                    <div>{formatNull(caseItem.applicant)}</div>
                    <div>
                      <a 
                        className='aWithLink'
                        onClick={() => {navigate(`/debtor/${caseItem.debtor_id}`, { state: { from: location.pathname + location.search + location.hash }})}}
                      >
                        {formatNull(caseItem.debtor_name)}
                      </a>
                    </div>
                    <div>
                      <a 
                        className='aWithLink'
                        onClick={() => {navigate(`/case/${caseItem.case_id}`, { state: { from: location.pathname + location.search + location.hash }})}}
                      >
                        {formatNull(caseItem.case_number)}
                      </a>
                    </div>
                    <div>
                      <p 
                        style={{width: 'fit-content'}}
                        className={`colorCell ${caseItem.results=='Нарушения установлены' ? 'red' : 'green'}`}
                      >
                        {(formatNull(caseItem.results))}
                      </p>
                    </div>
                    <div style={{alignItems: 'end'}}>
                      {isAdmin && (
                      <div className='horizontalCell'>
                        <IconContainer Icon={EyeIcon} onClick={() => {setCurrentId(caseItem.id); setIsFullInfoModal(true)}} size = '17' color = 'blue' className = '' />
                        <IconContainer Icon={PenIcon} onClick={() => {openSuperModal(caseItem.id, 'change')}} size = '17' color = 'blue' className = '' />
                        <ButtonWithConfirmation 
                            entryFunc={() => {deleteEntry(caseItem.id)}} 
                            Icon={TrashIcon} 
                            IconSize={17}
                            buttonName='Удалить' 
                            color='red' 
                        />
                      </div>)}
                  </div>
                </div>
                <div 
                    className='horizontalRow'
                    style={{ gridTemplateColumns: '1fr' }}
                >
                    {!caseItem.files || caseItem.files?.length===0 ?
                    <p className='description'>Файлы не прикреплены</p>
                    : caseItem.files?.map((fileInfo) => (
                        <button type='button' className='tableButton' onClick={() => {setCurrentFileId(fileInfo.id); setIsFileViewerModal(true)}}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="file"><path d="M20,8.94a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19l-.09,0L13.06,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V9S20,9,20,8.94ZM14,5.41,16.59,8H14ZM18,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4h5V9a1,1,0,0,0,1,1h5Z"></path></svg>
                            {fileInfo.name}
                        </button>
                    ))}
                </div>
            </div>
        ))}
      </div>
    </>
  )
}

export default Verifications;